// Article hero images — inline SVGs, no external deps

export const ImgVegetables = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#F0EBE0"/>
    <circle cx="580" cy="60" r="120" fill="#C84B0F" opacity="0.07"/>
    <circle cx="100" cy="240" r="90" fill="#2A7A40" opacity="0.07"/>
    <text x="340" y="90" textAnchor="middle" fontSize="72" fontFamily="sans-serif">🥦</text>
    <text x="160" y="110" textAnchor="middle" fontSize="52">🥕</text>
    <text x="520" y="110" textAnchor="middle" fontSize="52">🍅</text>
    <text x="260" y="180" textAnchor="middle" fontSize="44">🧅</text>
    <text x="420" y="180" textAnchor="middle" fontSize="44">🥬</text>
    <text x="90" y="180" textAnchor="middle" fontSize="38">🫑</text>
    <text x="590" y="185" textAnchor="middle" fontSize="38">🥒</text>
    <text x="340" y="255" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#8A7860" letterSpacing="2">USE UP YOUR VEGETABLES</text>
  </svg>
);

export const ImgPantry = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#EEE8DC"/>
    <circle cx="100" cy="80" r="100" fill="#B07C08" opacity="0.07"/>
    <circle cx="600" cy="220" r="110" fill="#C84B0F" opacity="0.07"/>
    <text x="340" y="95" textAnchor="middle" fontSize="68">🧂</text>
    <text x="160" y="115" textAnchor="middle" fontSize="50">🫒</text>
    <text x="520" y="115" textAnchor="middle" fontSize="50">🧄</text>
    <text x="240" y="190" textAnchor="middle" fontSize="44">🥫</text>
    <text x="440" y="190" textAnchor="middle" fontSize="44">🫘</text>
    <text x="100" y="200" textAnchor="middle" fontSize="36">🍯</text>
    <text x="580" y="200" textAnchor="middle" fontSize="36">🌾</text>
    <text x="340" y="255" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#8A7860" letterSpacing="2">THE ESSENTIAL PANTRY</text>
  </svg>
);

export const ImgBatch = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#F2EDE2"/>
    <circle cx="340" cy="140" r="160" fill="#C84B0F" opacity="0.05"/>
    <text x="340" y="100" textAnchor="middle" fontSize="72">🍲</text>
    <text x="155" y="115" textAnchor="middle" fontSize="50">🥘</text>
    <text x="525" y="115" textAnchor="middle" fontSize="50">🍚</text>
    <text x="220" y="200" textAnchor="middle" fontSize="42">🥗</text>
    <text x="460" y="200" textAnchor="middle" fontSize="42">🫙</text>
    <text x="90" y="210" textAnchor="middle" fontSize="34">📦</text>
    <text x="590" y="210" textAnchor="middle" fontSize="34">❄️</text>
    <text x="340" y="255" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#8A7860" letterSpacing="2">COOK ONCE, EAT ALL WEEK</text>
  </svg>
);

export const ImgSubstitutions = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#EDE8DC"/>
    <circle cx="200" cy="140" r="130" fill="#2A7A40" opacity="0.06"/>
    <circle cx="480" cy="140" r="130" fill="#C84B0F" opacity="0.06"/>
    <text x="190" y="130" textAnchor="middle" fontSize="62">🥛</text>
    <text x="340" y="120" textAnchor="middle" fontSize="36">🔄</text>
    <text x="490" y="130" textAnchor="middle" fontSize="62">🥥</text>
    <text x="130" y="210" textAnchor="middle" fontSize="40">🥚</text>
    <text x="260" y="210" textAnchor="middle" fontSize="28">→</text>
    <text x="340" y="210" textAnchor="middle" fontSize="40">🍌</text>
    <text x="420" y="210" textAnchor="middle" fontSize="28">→</text>
    <text x="550" y="210" textAnchor="middle" fontSize="40">🫐</text>
    <text x="340" y="260" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#8A7860" letterSpacing="2">SMART SUBSTITUTIONS</text>
  </svg>
);

export const ImgFoodWaste = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#EBF0E6"/>
    <circle cx="340" cy="100" r="180" fill="#2A7A40" opacity="0.07"/>
    <text x="340" y="100" textAnchor="middle" fontSize="68">🌱</text>
    <text x="160" y="115" textAnchor="middle" fontSize="50">♻️</text>
    <text x="520" y="115" textAnchor="middle" fontSize="50">🌍</text>
    <text x="240" y="195" textAnchor="middle" fontSize="42">🥦</text>
    <text x="440" y="195" textAnchor="middle" fontSize="42">💚</text>
    <text x="100" y="205" textAnchor="middle" fontSize="34">🛒</text>
    <text x="580" y="205" textAnchor="middle" fontSize="34">🏠</text>
    <text x="340" y="258" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#6A8A60" letterSpacing="2">REDUCE FOOD WASTE</text>
  </svg>
);

export const ImgKnife = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#F0EBE0"/>
    <circle cx="500" cy="80" r="130" fill="#C84B0F" opacity="0.06"/>
    <text x="340" y="105" textAnchor="middle" fontSize="72">🔪</text>
    <text x="140" y="110" textAnchor="middle" fontSize="52">🥕</text>
    <text x="540" y="110" textAnchor="middle" fontSize="52">🧅</text>
    <text x="220" y="195" textAnchor="middle" fontSize="38">🫑</text>
    <text x="340" y="200" textAnchor="middle" fontSize="36">✂️</text>
    <text x="460" y="195" textAnchor="middle" fontSize="38">🥒</text>
    <text x="100" y="205" textAnchor="middle" fontSize="32">🧄</text>
    <text x="580" y="205" textAnchor="middle" fontSize="32">🌿</text>
    <text x="340" y="258" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#8A7860" letterSpacing="2">KNIFE SKILLS GUIDE</text>
  </svg>
);

export const ImgSeasoning = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#EDE8DC"/>
    <circle cx="200" cy="200" r="140" fill="#B07C08" opacity="0.07"/>
    <circle cx="520" cy="80" r="110" fill="#C84B0F" opacity="0.07"/>
    <text x="340" y="100" textAnchor="middle" fontSize="68">🧂</text>
    <text x="155" y="120" textAnchor="middle" fontSize="50">🍋</text>
    <text x="525" y="120" textAnchor="middle" fontSize="50">🧄</text>
    <text x="240" y="200" textAnchor="middle" fontSize="42">🌶️</text>
    <text x="340" y="200" textAnchor="middle" fontSize="42">✨</text>
    <text x="440" y="200" textAnchor="middle" fontSize="42">🫙</text>
    <text x="100" y="210" textAnchor="middle" fontSize="34">🧈</text>
    <text x="580" y="210" textAnchor="middle" fontSize="34">🍷</text>
    <text x="340" y="258" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#8A7860" letterSpacing="2">THE ART OF SEASONING</text>
  </svg>
);

export const ImgProtein = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#F0EBE0"/>
    <circle cx="340" cy="140" r="170" fill="#C84B0F" opacity="0.06"/>
    <text x="340" y="100" textAnchor="middle" fontSize="70">🍗</text>
    <text x="155" y="115" textAnchor="middle" fontSize="52">🥩</text>
    <text x="525" y="115" textAnchor="middle" fontSize="52">🐟</text>
    <text x="240" y="200" textAnchor="middle" fontSize="40">🌡️</text>
    <text x="340" y="205" textAnchor="middle" fontSize="40">🍳</text>
    <text x="440" y="200" textAnchor="middle" fontSize="40">🦐</text>
    <text x="100" y="210" textAnchor="middle" fontSize="32">⏱️</text>
    <text x="580" y="210" textAnchor="middle" fontSize="32">🔥</text>
    <text x="340" y="258" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#8A7860" letterSpacing="2">COOK PROTEIN PERFECTLY</text>
  </svg>
);

export const ImgMealPlan = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#EDE8F0"/>
    <circle cx="100" cy="100" r="110" fill="#7C3AED" opacity="0.06"/>
    <circle cx="580" cy="200" r="100" fill="#C84B0F" opacity="0.06"/>
    <text x="340" y="100" textAnchor="middle" fontSize="70">🗓️</text>
    <text x="155" y="115" textAnchor="middle" fontSize="50">🥗</text>
    <text x="525" y="115" textAnchor="middle" fontSize="50">🍲</text>
    <text x="240" y="200" textAnchor="middle" fontSize="42">📝</text>
    <text x="340" y="205" textAnchor="middle" fontSize="42">🛒</text>
    <text x="440" y="200" textAnchor="middle" fontSize="42">✅</text>
    <text x="100" y="210" textAnchor="middle" fontSize="34">🌅</text>
    <text x="580" y="210" textAnchor="middle" fontSize="34">🍽️</text>
    <text x="340" y="258" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#8A7860" letterSpacing="2">MEAL PLANNING GUIDE</text>
  </svg>
);

export const ImgBudget = () => (
  <svg viewBox="0 0 680 280" xmlns="http://www.w3.org/2000/svg" style={{width:'100%',display:'block'}}>
    <rect width="680" height="280" fill="#EBF0E8"/>
    <circle cx="200" cy="80" r="120" fill="#2A7A40" opacity="0.07"/>
    <circle cx="520" cy="200" r="100" fill="#B07C08" opacity="0.07"/>
    <text x="340" y="100" textAnchor="middle" fontSize="68">💰</text>
    <text x="155" y="115" textAnchor="middle" fontSize="50">🫘</text>
    <text x="525" y="115" textAnchor="middle" fontSize="50">🥚</text>
    <text x="240" y="200" textAnchor="middle" fontSize="42">🍋</text>
    <text x="340" y="200" textAnchor="middle" fontSize="42">💚</text>
    <text x="440" y="200" textAnchor="middle" fontSize="42">🥕</text>
    <text x="100" y="210" textAnchor="middle" fontSize="34">🌿</text>
    <text x="580" y="210" textAnchor="middle" fontSize="34">🛒</text>
    <text x="340" y="258" textAnchor="middle" fontFamily="Georgia,serif" fontSize="15" fill="#6A8A60" letterSpacing="2">BUDGET COOKING</text>
  </svg>
);
